// extracted by mini-css-extract-plugin
module.exports = {"feedbackForm":"b8_ls","feedbackForm_isNegative":"b8_lt","feedbackForm__success":"b8_lv","feedbackForm__fields_isHidden":"b8_lw"};